import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaSun, FaMoon, FaBars, FaTimes } from "react-icons/fa";

export default function Nav({ theme, setTheme }) {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="nav">
      <Link to="/" className="brand">Nameless<span>Mind</span></Link>
      <div className="nav-group">
        <nav className="nav-links">
          {isHome ? (
            <>
              <a href="#projects">Projects</a>
              <a href="#skills">Skills</a>
              <a href="#about">About</a>
              <a href="#contact">Contact</a>
            </>
          ) : (
            <Link to="/" onClick={() => window.scrollTo(0, 0)}>Home</Link>
          )}
        </nav>
        <button className="theme-btn" aria-label="Toggle theme" onClick={() => setTheme(t => (t === "dark" ? "light" : "dark"))}>
          {theme === "dark" ? <FaSun /> : <FaMoon />}
        </button>
        <button className="menu-btn" aria-label="Toggle mobile menu" onClick={() => setMobileOpen(!mobileOpen)}>
          {mobileOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>
      <div className={`mobile-menu ${mobileOpen ? "open" : ""}`}>
        {isHome ? (
          <>
            <a href="#projects" onClick={() => setMobileOpen(false)}>Projects</a>
            <a href="#skills" onClick={() => setMobileOpen(false)}>Skills</a>
            <a href="#about" onClick={() => setMobileOpen(false)}>About</a>
            <a href="#contact" onClick={() => setMobileOpen(false)}>Contact</a>
          </>
          ) : (
            <Link to="/" onClick={() => { setMobileOpen(false); window.scrollTo(0, 0); }}>Home</Link>
        )}
      </div>
    </header>
  );
}
